import BlogLandingTemplate from '@/components/template/BlogLandingTemplate';
import { BlogLandingTemplateProps } from '@/components/template/BlogLandingTemplate/BlogLandingTemplate';
import { mapBlogResponseToBlogPreview } from '@/lib/blog';
import { SEOMetaTags } from '@/lib/seo/seoTags';
import { getBlogPosts } from '@/services/wordpress/articles';
import { getCategories } from '@/services/wordpress/categories';
import { RawBlogType } from '@/types/blog';
import { BasePageProps } from '@/types/page';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';

const Blog: React.FC<BlogLandingTemplateProps> = ({ posts, categories }) => {
  return (
    <main>
      <BlogLandingTemplate posts={posts} categories={categories} />
    </main>
  );
};

export const getStaticProps: GetStaticProps<BlogLandingTemplateProps> = async ({
  locale,
}) => {
  try {
    const [blogPostsResponse, categoriesWithCount] = await Promise.all([
      getBlogPosts({
        fields: ['id', 'title', 'excerpt', 'slug', 'date'],
        getCategoriesAndFeaturedImage: true,
        per_page: 4,
      }),
      getCategories({ fields: ['id', 'name', 'count'] }),
    ]);

    const blogPosts: RawBlogType[] = await blogPostsResponse.json();

    return {
      props: {
        ...(await serverSideTranslations(locale ?? 'en', ['common'])),
        posts: mapBlogResponseToBlogPreview(blogPosts),
        categories: categoriesWithCount
          .sort((a, b) => b.count - a.count)
          .map((c) => ({ id: c.id.toString(), name: c.name })),
        metadata: {
          title: SEOMetaTags.blogPage.title,
          description: SEOMetaTags.blogPage.description,
        },
      } satisfies BasePageProps<BlogLandingTemplateProps>,
      revalidate: 100,
    };
  } catch (err) {
    return {
      notFound: true,
      revalidate: 1,
    };
  }
};

export default Blog;
